export class Document {
  documentId
  applicationId
  name
  size
  mimetype
  documentURL

  constructor(document = {}) {
    this.documentId = document.documentId ? String(document.documentId) : ''
    this.applicationId = document.applicationId ? String(document.applicationId) : ''
    this.name = document.name ? String(document.name) : ''
    this.size = document.size ? Number(document.size) : 0
    this.mimetype = document.mimetype ? String(document.mimetype) : ''
    this.documentURL = document.documentURL ? String(document.documentURL) : ''
  }
}